module.exports = __webpack_public_path__ + "static/media/historyList.638512da.svg";